"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _views = require("../views");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AnimatedViewWrapper = function AnimatedViewWrapper(_ref) {
  var currentIndex = _ref.currentIndex,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["currentIndex", "children"]);

  return _react.default.createElement(_views.TabPanelContainer, props, _react.default.createElement(_views.TabPanelGroup, {
    index: currentIndex
  }, children.map(function (child, index) {
    return _react.default.createElement(_views.TabPanel, {
      key: index,
      role: "tabpanel",
      id: "full-width-tabpanel-".concat(index),
      "aria-labelledby": "full-width-tab-".concat(index),
      numberOfChildren: children && children.length || 1
    }, _react.default.cloneElement(child, {
      active: currentIndex === index
    }));
  })));
};

AnimatedViewWrapper.propTypes = {
  currentIndex: _propTypes.default.number.isRequired,
  children: _propTypes.default.node
};
AnimatedViewWrapper.defaultProps = {
  children: []
};
var _default = AnimatedViewWrapper;
exports.default = _default;